// extracted by mini-css-extract-plugin
export default {"container":"RelatedVideos_container__cY6Qy","listBox":"RelatedVideos_listBox__NwIZo"};